/** @file The Timeline panel with its open animation remembered per project across reloads (walkthrough D8). */
import type { IDockviewPanelProps } from 'dockview-react';
import { useEffect } from 'react';
import { rememberAnimation, type AnimationStorage } from './rememberAnimation';
import { TimelinePanel } from './TimelinePanel';

/** localStorage, or null where reading it throws (blocked site data) or it does not exist. */
function browserStorage(): AnimationStorage | null {
  try {
    return typeof localStorage === 'undefined' ? null : localStorage;
  } catch {
    return null;
  }
}

/** Mounted once with the editor frame (the Timeline renders `always`), so the restore runs when the document arrives. */
export function RememberedTimeline(props: IDockviewPanelProps) {
  useEffect(() => rememberAnimation(browserStorage()), []);
  return <TimelinePanel {...props} />;
}
